import React from "react";
import { PAGE_SEO_CONTENT } from "./content";

const PageSeoContent = ({ variant = "home", title: titleOverride }) => {
  const content = PAGE_SEO_CONTENT[variant];
  if (!content) return null;

  const title = titleOverride || content.title;
  const { paragraphs } = content;

  return (
    <section className="page-seo-content wow fadeInUp" data-wow-delay="0.2s">
      <div className="container">
        <h1 className="page-seo-content__title">{title}</h1>
        {paragraphs.map((paragraph, index) => (
          <p key={index} className="page-seo-content__text">
            {paragraph}
          </p>
        ))}
      </div>
    </section>
  );
};

export default PageSeoContent;
